import 'normalize.css'
import 'plyr/dist/plyr.css'
import '../styles/styles.scss'
import svg4everybody from 'svg4everybody'

import { Navigation } from './modules/navigation'
import { Discovery } from './modules/discovery'
import { Overlay } from './modules/overlay'
import { SingleFilm } from './modules/single-film'
import { Lists } from './modules/lists'
import { FilmPlayer } from './modules/film-player'

// Polyfill for SVG sprites in older browsers
svg4everybody()

// Initialize modules when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}

function init(): void {
  new Navigation()
  new Discovery()
  new Overlay()
  new SingleFilm()
  new Lists()
  new FilmPlayer()
}
